import { fetchPosts, getSummarized, byUser, getPost, savePost } from '../api/posts'
import { linksToHtml, sanitizeText } from '../helpers'
import { notifyError } from './logger'
import env from '../env'

export const CATEGORIES = ['most_commented', 'starred', 'delpastor']

/**
 * This function handles fetching and returning
 * the processed posts, serving as a factory.
 *
 * @param string category
 * @returns object
 */
export const getPosts = async params => {
  const { path, category, summarized, id, next } = params
  const isUser = path?.indexOf('user') !== -1

  if (category && !CATEGORIES.includes(category)) {
    throw new Error('Invalid category')
  }

  const action = summarized ? getSummarized : isUser ? byUser : id ? getPost : fetchPosts
  const payload = id || category || ''

  let posts = []
  let nextPage

  try {
    const { data } = await action(payload, next)
    posts = processedPosts(data.data)
    nextPage = data.next_page_url ? '?' + data.next_page_url.split('?')[1] : null
  } catch (err) {
    notifyError(err)
    throw new Error(err.message)
  }

  return {
    posts,
    nextPage,
  }
}

/**
 * This function receives an array of posts and
 * returns an array of processed posts.
 *
 * @param array posts
 * @returns array
 */
export const processedPosts = posts => {
  if (!posts) return []

  return posts.map(post => {
    const sanitizedText = sanitizeText(post.content)
    return { ...post, content: linksToHtml(sanitizedText) }
  })
}

/**
 * This function receives a post id
 * returns the url to share the post.
 *
 * @param int postId
 * @returns string
 */
export const getPostUrl = postId => {
  return `${env.siteUrl}/posts/${postId}`
}

/**
 * This function checks an empty post body
 *
 * @param string body
 * @returns
 */
export const isPostBodyEmpty = body => {
  if (body.trim().length > 0) return false
  return true
}

/**
 * This function submits the post to the server
 *
 * @param object payload
 * @returns
 */
export const submitPost = async payload => {
  try {
    console.debug('Saving Post with payload', payload)
    const {
      data: { data },
    } = await savePost(payload)

    return {
      ...data,
      ...{
        post_media: [],
        count_comments: 0,
        count_reactions: 0,
        display_name: data.user_display_name,
      },
    }
  } catch (err) {
    notifyError(err)
    throw new Error(`Error al guardar el post, ${err.message}`)
  }
}
